import {
  Button,
  Card,
  Heading,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
  Text,
} from "@softmax/design-system";
import { PolicyStateFeedback, type PolicyRefreshState } from "../policy-state";
import type { PolicyVersionSubmission } from "../policy-version-records";

export type PolicyVersionSubmissionsProps = {
  readonly submissions:
    | { readonly status: "hidden" }
    | { readonly status: "loading" }
    | { readonly status: "error"; readonly message: string }
    | {
        readonly status: "ready";
        readonly rows: readonly PolicyVersionSubmission[];
        readonly refresh?: PolicyRefreshState | undefined;
      };
  readonly onRetry?: (() => void) | undefined;
  readonly onOpenLeague: (id: string) => void;
};

export function PolicyVersionSubmissions({
  submissions,
  onRetry,
  onOpenLeague,
}: PolicyVersionSubmissionsProps) {
  return (
    submissions.status !== "hidden" && (
      <Card>
        <Stack width="auto">
          <Heading level={2}>Submissions</Heading>
          <PolicyStateFeedback
            state={submissions}
            subject="submissions"
            onRetry={onRetry}
          />
          {submissions.status === "ready" &&
            (submissions.rows.length === 0 ? (
              <Text tone="muted">No submissions for this version yet.</Text>
            ) : (
              <TableContainer aria-label="Policy version submissions">
                <Table density="compact">
                  <TableHead>
                    <TableRow>
                      <TableHeaderCell>League</TableHeaderCell>
                      <TableHeaderCell>Status</TableHeaderCell>
                      <TableHeaderCell>Submitted</TableHeaderCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {submissions.rows.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>
                          <Button
                            size="sm"
                            variant="quiet"
                            onClick={() => onOpenLeague(row.leagueId)}
                          >
                            {row.leagueName}
                          </Button>
                        </TableCell>
                        <TableCell>{row.status}</TableCell>
                        <TableCell>{row.submittedAt}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ))}
        </Stack>
      </Card>
    )
  );
}
